import { PlatformEnvData, SessionServiceAPI } from '@wix/thunderbolt-symbols'

export const biFactory = ({ biData, metaSiteId, viewMode, sessionService }: { biData: PlatformEnvData['bi']; metaSiteId: string; viewMode: 'site' | 'preview'; sessionService: SessionServiceAPI }) => {
	const {
		viewerSessionId,
		requestId,
		initialTimestamp,
		initialRequestTimestamp,
		isCached,
		is_rollout,
		dc,
		isjp,
		btype,
		viewerVersion,
		pageData: { isLightbox, pageUrl, pageId, pageNumber },
		muteBi,
		ownerId,
		isMobileFriendly,
		isPreview,
		svSession,
	} = biData

	return {
		// wixBiSession data
		viewerSessionId,
		get visitorId() {
			return sessionService.getVisitorId()
		},
		requestId,
		get siteMemberId() {
			return sessionService.getSiteMemberId()
		},
		isCached,
		is_rollout,
		dc,
		isjp,
		btype,
		pageLoadStart: initialTimestamp,
		networkPageLoadStart: initialRequestTimestamp,
		pageNumber,
		// rendererModel data
		metaSiteId,
		ownerId,
		isMobileFriendly,
		viewMode,
		isPreview,
		svSession,
		// viewer data
		pageId,
		pageUrl,
		isServerSide: !process.env.browser,
		viewerName: 'thunderbolt',
		artifactVersion: `thunderbolt-${viewerVersion}`,
		isPopup: isLightbox,
		// query params data
		muteBi,
	}
}
